class Calendar {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-tab-trigger li:first-child').addClass('active');
    $(".js-tab-inner ul:first-of-type").css("display", "block");
    let date = new Date();

    $('.js-change-date').html(`${date.getFullYear()}年 ${date.getMonth() + 1}月`)

    let swiper = new Swiper(".calendarSwiper", {
      initialSlide: $(`[data-year="${date.getFullYear()}"][data-month="${date.getMonth() + 1}"]`).index(),
      navigation: {
        nextEl: ".next-btn",
        prevEl: ".prev-btn",
      },
      threshold: 999999,
      spaceBetween: 20,
      speed: 500,
    });

    swiper.on('slideChangeTransitionStart', function () {
      $('.js-change-date').html($('.swiper-slide-active').data('date'));
    });
  }
}